
import CalPara from "./cal-para.vue";
import CalCenterHeading from "./cal-center-heading.vue";
export default {
  components: { CalPara, CalCenterHeading },
  name: "SignupPopup",
  props: ["paraContent", "headingContent", "btnText", "closeSignupAlertDialog"],
};
